import gql from "graphql-tag";
import { LangCode } from "../../../_common/types.js";

export interface GetRequestFormContentVariables {
    langCode: LangCode;
}

export interface GetRequestFormContentData {
    staticContent: {
        id: string;
        contentLangs: LangCode[];
        content: {
            title: string;
            text: string;
            metaTitle: string;
            metaDescription: string;
            commentsLbl: string;
            confirmText: string;
            countryLbl: string;
            optDeleteInfo: string;
            optMarketing: string;
            optOther: string;
            optProvideInfo: string;
            optUpdateInfo: string;
            purposeLbl: string;
        };
    };
    countries: Country[];
}
export interface Country {
    id: string;
    code: string;
    content: {
        langCode: LangCode;
        name: string;
    };
}
export const GET_REQUEST_FORM_CONTENT = gql`
    query getRequestFormContent($langCode: LangCode) {
        staticContent(id: "vt-site-data-subject-request-form") {
            id
            contentLangs
            content(langCode: $langCode)
        }
        countries {
            id
            code
            content(langCode: $langCode) {
                langCode
                name
            }
        }
    }
`;
